import type { Field } from '.'

export const RENDERER: Field[] = [
  {
    key: 'background',
  },
  {
    key: 'camera',
    path: 'activeCamera',
    fields: [
      {
        key: 'focalPoint',
      },
      {
        key: 'parallelProjection'
      },
      {
        key: 'position',
      },
      {
        key: 'viewUp',
      },
      {
        key: 'directionOfProjection',
      },
    ]
  },
]

export const LEGEND: Field[] = [
  {
    key: 'axisLabel',
  },
  {
    key: 'drawNanAnnotation',
  },
  {
    key: 'visibility',
  },
]

export const SCENE: Field[] = [
  {
    key: 'visibility',
  },
  {
    key: 'origin',
  },
  {
    key: 'position',
  },
  {
    key: 'scale',
  },
  {
    key: 'legend',
    fields: [
      {
        key: 'axisLabel',
      },
      {
        key: 'drawNanAnnotation',
      },
      {
        key: 'visibility',
      },
      {
        key: 'tickTextStyle',
      },
      {
        key: 'axisTextStyle',
      },
      {
        key: 'units',
      },
      {
        key: 'slot'
      },
    ]
  },
  {
    key: 'mapper',
    fields: [
      {
        key: 'units'
      },
      {
        key: 'colorSet'
      },
      {
        key: 'inputData',
        fields: [
          {
            key: 'cellData',
            fields: [
              {
                key: 'numberOfArrays'
              },
              {
                key: 'arrays',
                fields: [
                  {
                    key: 'name',
                  },
                  {
                    key: 'range'
                  },
                ]
              },
            ]
          },
          {
            key: 'pointData',
            fields: [
              {
                key: 'numberOfArrays'
              },
              {
                key: 'arrays',
                fields: [
                  {
                    key: 'name',
                  },
                  {
                    key: 'range'
                  },
                ]
              },
            ]
          },
        ]
      },
      {
        key: 'lookupTable',
        fields: [
          {
            key: 'mappingRange',
          }
        ]
      },
      {
        key: 'colorByArrayName',
      },
      {
        key: 'colorMode'
      },
      {
        key: 'scalarRange'
      },
      {
        key: 'scalarMode'
      },
    ]
  },
  {
    key: 'property',
    fields: [
      {
        key: 'diffuseColor',
      },
      {
        key: 'opacity',
      },
      {
        key: 'pointSize',
      },
      {
        key: 'representation',
      },
      {
        key: 'representationAsString'
      },
      {
        key: 'edgeVisibility',
      },
      {
        key: 'edgeColor'
      },
      {
        key: 'lineWidth',
      },
    ]
  },
]

export const WIDGET_MANAGER: Field[] = [
  {
    key: 'widgets',
    fields: [ 
      {
        key: 'widgetState',
        fields: [
          {
            key: 'origin'
          },
          {
            key: 'normal'
          },
          {
            key: 'bounds'
          },
        ]
      },
      {
        key: 'visibility'
      }
    ]
  }
]